export * from './profile-avatar.component';
export * from './profile-avatar.module';